module.exports = __webpack_public_path__ + "static/vdl-church-ipad2-dae18fe6c2def64276954c3e79060370.png";